import GlobalQuickJump from "../../../../../global/GlobalQuickJump";

export default function MaintenanceQuickJumpSection(props) {
  return <GlobalQuickJump {...props} />;
}
